import React from "react";
import SocialLinks from "./SocialLinks";
import PrivacyChoicesLabel from "../common/PrivacyChoicesLabel";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

function Footer() {
  const location = useLocation();
  const location_path = location?.pathname;
  const current_page = location_path.split("/")[1];

  const site_settings = useSelector(
    (state) => state.fetchSiteSettings.site_settings
  );
  return (
    <>
      {current_page === "login" ||
      current_page === "signup" ||
      current_page === "enterprise-checkout" ||
      current_page === "checkout" ? (
        ""
      ) : (
        <footer className="" style={{ padding: "80px 0" }}>
          <div className="container" style={{display: 'flex', flexDirection: 'column'}}>
            <div className="rowCustom row g-4">
              <div className="col-12 col-md-6 col-lg-3">
                <div className="f_logo">
                  <img
                    src="/assets/rhino-company-logo.svg"
                    alt="company logo"
                    width={"142px"}
                    className="company-logo"
                  />
                  <p>Direct access to comprehensive property data and owner contact information.
                  </p>
                  <a
                    href="mailto:support@rhinorecon.com"
                    // className="d-flex gap-2 mb-2"
                    style={{
                      display: "flex",
                      gap: "10px",
                      marginBottom: "10px",
                      alignItems: "center",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M13.7663 4.38037L8.1396 7.96441C7.94866 8.07532 7.73178 8.13373 7.51096 8.13373C7.29015 8.13373 7.07327 8.07532 6.88233 7.96441L1.25 4.38037"
                        stroke="#D1D5DC"
                        stroke-width="1.25163"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12.5147 2.50293H2.50163C1.81037 2.50293 1.25 3.0633 1.25 3.75456V11.2643C1.25 11.9556 1.81037 12.516 2.50163 12.516H12.5147C13.2059 12.516 13.7663 11.9556 13.7663 11.2643V3.75456C13.7663 3.0633 13.2059 2.50293 12.5147 2.50293Z"
                        stroke="#D1D5DC"
                        stroke-width="1.25163"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <p className="email">support@rhinorecon.com</p>
                  </a>
                  <a
                    href="tel:+1 844-744-6646"
                    style={{
                      display: "flex",
                      gap: "10px",
                      marginBottom: "10px",
                      alignItems: "center",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_797_5156)">
                        <path
                          d="M8.65464 10.3688C8.78389 10.4282 8.9295 10.4417 9.06749 10.4073C9.20547 10.3728 9.3276 10.2924 9.41375 10.1792L9.63592 9.8882C9.7525 9.73275 9.90368 9.60658 10.0775 9.51968C10.2513 9.43279 10.4429 9.38755 10.6372 9.38755H12.5147C12.8466 9.38755 13.165 9.51941 13.3997 9.75414C13.6344 9.98887 13.7663 10.3072 13.7663 10.6392V12.5166C13.7663 12.8486 13.6344 13.1669 13.3997 13.4017C13.165 13.6364 12.8466 13.7683 12.5147 13.7683C9.52709 13.7683 6.66188 12.5814 4.54934 10.4689C2.43681 8.35637 1.25 5.49116 1.25 2.50358C1.25 2.17163 1.38187 1.85327 1.61659 1.61855C1.85132 1.38382 2.16968 1.25195 2.50163 1.25195H4.37907C4.71103 1.25195 5.02938 1.38382 5.26411 1.61855C5.49884 1.85327 5.6307 2.17163 5.6307 2.50358V4.38103C5.6307 4.57534 5.58546 4.76698 5.49857 4.94077C5.41167 5.11457 5.2855 5.26575 5.13005 5.38233L4.83717 5.60199C4.72228 5.68972 4.6413 5.81451 4.60799 5.95517C4.57468 6.09583 4.59109 6.24369 4.65443 6.37362C5.50972 8.1108 6.91639 9.51571 8.65464 10.3688Z"
                          stroke="#D1D5DC"
                          stroke-width="1.25163"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_797_5156">
                          <rect width="15.0196" height="15.0196" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <p className="phone">+1 &nbsp;844-RHINO-GO</p>
                  </a>
                  <img
                    src="/assets/georgia-award.svg"
                    alt="georgia award"
                    style={{ maxWidth: "91px" }}
                  />
                </div>
              </div>
              <div className="col-md-1 d-none d-md-block"></div>
              <div className="col-6 col-md-6 col-lg-2">
                <h5>Company</h5>
                <ul className="lst">
                  <li>
                    <a href="/about-us">About Us</a>
                  </li>
                </ul>
              </div>
              <div className="col-6 col-md-6 col-lg-2">
                <h5>Product</h5>
                <ul className="lst">
                  <li>
                    <a href="/pricing">Pricing</a>
                  </li>
                </ul>
              </div>
              <div className="col-6 col-md-6 col-lg-2">
                <h5>Resources</h5>
                <ul className="lst">
                  <li>
                    <a href="/help">Help Center</a>
                  </li>
                  <li>
                    <a href="/support">Support</a>
                  </li>
                </ul>
              </div>
              <div className="col-6 col-md-6 col-lg-2">
                <h5>Legal</h5>
                <ul className="lst">
                  <li>
                    <a href="/privacy-policy">Privacy Policy</a>
                  </li>
                  <li>
                    <a href="/do-not-sell-my-info">
                      <PrivacyChoicesLabel />
                    </a>
                  </li>
                  <li>
                    <a href="/terms-conditions">Terms of Service</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="copy_right">
              <div className="_inner">
                <p className="mb-0">
                  © {new Date().getFullYear()} Rhino Recon. All rights reserved.
                </p>
                <ul class="social_lnks">
                  <li>
                    <a
                      href="https://www.facebook.com/profile.php?id=61563469913697"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="white"
                      >
                        <path d="M22.675 0h-21.35c-.732 0-1.325.593-1.325 1.325v21.351c0 .731.593 1.324 1.325 1.324h11.495v-9.294h-3.128v-3.622h3.128v-2.671c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12v9.293h6.116c.73 0 1.323-.593 1.323-1.325v-21.35c0-.732-.593-1.325-1.325-1.325z" />
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/therhino_recon/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="white"
                      >
                        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://x.com/RhinoRecon"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="white"
                      >
                        <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z" />
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/company/rhino-recon/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="white"
                      >
                        <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                      </svg>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </footer>
      )}
    </>
  );
}

export default Footer;
